import { AxiosError } from 'axios';

import { getApiClient } from './api.base';
import {clearLoading, setDonationsLoading} from '@/services/utils/loading.service';
import { FundraisingDonationsResponse } from '@/models/fundraising-donations-response.model';

type Response = FundraisingDonationsResponse & AxiosError;

export const fundraisingProjectDonationsService = async (
    projectId: string,
    query: string
): Promise<Response> => {
    setDonationsLoading();
    try {
        const response = await getApiClient('search').get(
            `/api/v1/fundraising/detail/${projectId}/donations?${query}`
        );
        return response.data as Response;
    } catch (errorResponse) {
        const error = errorResponse as Response;
        console.info(error);
        clearLoading();
        return error;
    }
};
